import type {
  ExtensionUser,
  ExtensionsCommandFactory,
} from '../ExtensionsModel';
import { getExtensions } from './api/getExtensionsApi';
import { getUsers } from './api/getUsersApi';

export const fetchExtensions: ExtensionsCommandFactory<void> =
  (cmdContext) => async () => {
    try {
      cmdContext.updateState((draft) => {
        draft.extensionsLoading = true;
      });

      const [extensionsResponse, usersResponse] = await Promise.all([
        getExtensions(cmdContext.api),
        getUsers(cmdContext.api),
      ]);

      cmdContext.updateState((draft) => {
        draft.extensions = [...extensionsResponse.extensions];
        draft.platformUsers = [
          ...usersResponse.data.map(
            (user): ExtensionUser => ({
              id: user.id,
              username: user.username,
            }),
          ),
        ];
      });
    } finally {
      cmdContext.updateState((draft) => {
        draft.extensionsLoading = false;
      });
    }
  };
